import { DateInput } from "react-admin";

const dateToLocalDatetimeStart = (dateStr) =>
  dateStr ? new Date(dateStr + "T00:00:00").toISOString() : dateStr;

export const MyDateInput = (props) => {
  return <DateInput parse={dateToLocalDatetimeStart} {...props} />;
};
